$(function() {

  'use strict';

  var _this,
      _window = $(window);

  /**
   * タブ
   */
  $(function() {
    var tabConts = $('#recruit .careers .careers-tab-contents'),
        menu     = $('#recruit .careers .js-tab-menu');

    TAB_SWITCH(tabConts, menu);
  });

  /**
   * SPプルダウン / SPタブ
   */
  $(function() {
    // プルダウン
    var pullDownTrigger = $('#recruit .js-pulldown-trigger'),
        pullDownItem    = $('#recruit .submenu__child-item a'),
        spTabMenu       = $('#recruit .js-sp-tab-menu');

    pullDownTrigger.on('click', function() {
      _this = $(this);

      if(_window.width() <= 1024) {
        _this.toggleClass('is-slide');
      } else {
        _this.removeClass('is-slide');
      }
    });

    if(_window.width() <= 1024) {
      spTabMenu.addClass('is-no-smooth');
    } else {
      spTabMenu.removeClass('is-no-smooth');
    }

    _window.on('resize', function() {
      if(_window.width() <= 1024) {
        spTabMenu.addClass('is-no-smooth');
      } else {
        spTabMenu.removeClass('is-no-smooth');
      }
    });

    pullDownItem.on('click', function() {
      _this = $(this);

      if(_window.width() <= 1024) {
        pullDownTrigger.removeClass('is-slide');
      }
    });

    // タブメニュー
    $(function() {
      var spTabMenu = $('#recruit .careers .js-sp-tab-menu'),
          spTabWrap = $('#recruit .careers .careers-tab-contents');

      /* タブScript */
      /*
      spTabWrap.each(function() {
        _this = $(this);

        if(_window.width() <= 1024) {
          _this.find('.jobs:not(:first)').hide();
        }
      });

      spTabMenu.on('click', function() {
        _this = $(this);

        var conts = _this.parents('.careers-tab-contents'),
            index = conts.find('.js-sp-tab-menu').index(this);

        if(_window.width() <= 1024) {
          conts.find('#recruit .careers .jobs').hide();
          conts.find('#recruit .careers .jobs:eq(' + index + ')').show();

          return false;
        }
      });
      */

      /////////////////////////// タブScript/////////
      var index = 0;

      spTabWrap.each(function() {
        _this = $(this);

        if($.cookie('CHILD_TAB')) {
          if(_window.width() <= 1024) {
            index = $.cookie('CHILD_TAB');

            _this.find('.jobs:not(:first)').hide();
          }
        }
      });

      spTabMenu.on('click', function() {
        _this = $(this);

        if(_window.width() <= 1024) {
          var conts = _this.parents('.careers-tab-contents');

          index = conts.find('.js-sp-tab-menu').index(this);

          conts.find('.jobs').hide();
          conts.find('.jobs:eq(' + index + ')').show();

          $.cookie('CHILD_TAB', index, {
            expires: 1
          });

          return false;
        }
      });

      /* リサイズ時の表示切り替え
      _window.on('resize', function() {
        spTabWrap.each(function() {
          _this = $(this);

          if(_window.width() <= 1024) {
            _this.find('.jobs:not(:first)').hide();
          } else {
            spTabWrap.find('.jobs').show();
          }
        });
      });
      */

      // リサイズ時の表示切り替え
      var currentWidth = window.innerWidth;

      window.addEventListener('resize', function() {
        spTabWrap.each(function() {
          _this = $(this);

          if(_window.width() <= 1024) {
            if(currentWidth == window.innerWidth) {
              return;
            }

            currentWidth = window.innerWidth;
            _this.find('.jobs:not(:first)').hide();
          } else {
            spTabWrap.find('#recruit .careers .jobs').show();
          }
        });
      });
    });
  });

  // tab ダイレクトリンク
  $(window).on('load', function() {
    var url = document.URL;

    if(url.indexOf('#')) {
      var hash = url.split('#')[1];

      if(hash) {
        hash = hash.split('&id=')[0];

        var conts = $('#recruit .careers-tab-contents');
        var cont  = {
          NEW:    $('#recruit #NEW'),
          MID:    $('#recruit #MID'),
          INTERN: $('#recruit #INTERN'),
          OTHERS: $('#recruit #OTHERS')
        };

        var tabs = $('#recruit .js-tab-menu');
        var tab  = {
          NEW:    $('#recruit .js-tab-menu-new'),
          MID:    $('#recruit .js-tab-menu-mid'),
          INTERN: $('#recruit .js-tab-menu-intern'),
          OTHERS: $('#recruit .js-tab-menu-others')
        };

        conts.css('display', 'none');
        cont[hash].css('display', 'block');
        tabs.removeClass('is-active');
        tab[hash].addClass('is-active');

        // SP
        if(_window.width() <= 1024) {
          hash = url.split('&id=')[1];

          $('#recruit .careers .jobs').css('display', 'none');
          $('#recruit .careers .jobs#' + hash).css('display', 'block');
        }
      }
    }
  });

  // インタビューページ ”続きを見る”クリックアニメーション
  $('.more').on('click', function(){
    $(this).parent().addClass('more-active');
    $(this).parent().prev('ul').addClass('more-active');
  });
  // var mores = document.querySelectorAll('.more')
  // var articleBottoms =  document.querySelectorAll('.article-bottom--style')
  // mores.forEach(function(target) {
  //   target.addEventListener('click', function(){
  //     articleBottoms.forEach(function(target){
  //       target.classList.add('more-active');
  //     });
  //   }, false);
  // })
});
